export const projectsData = [
	{
		id: 1,
		title: 'Ndimofor Aretas Porfolio 1.0',
		image: 'https://i.postimg.cc/VNJx5bbj/my-first-portfolio-min.png',
		description:
			'This is my first personal project based on just HTML, CSS, Javascript and A free API (For the Quote generator). No Frameworks involved!',
		link: 'https://ndimofor-aretas.netlify.app/',
	},

	{
		id: 2,
		title: 'Ndimofor Aretas Porfolio 1.0',
		image: 'https://i.postimg.cc/7YDrX6pk/the-omnifood-project-min.png',
		description:
			'This is my first personal project based on just HTML, CSS, Javascript and A free API (For the Quote generator). No Frameworks involved!',
		link: 'https://ndimofor-aretas.netlify.app/',
	},

	{
		id: 3,
		title: 'Ndimofor Aretas Porfolio 1.0',
		image: 'https://i.postimg.cc/XYYSSPj1/grunwald-translate-official-min.png',
		description:
			'This is my first personal project based on just HTML, CSS, Javascript and A free API (For the Quote generator). No Frameworks involved!',
		link: 'https://ndimofor-aretas.netlify.app/',
	},

	{
		id: 4,
		title: 'Ndimofor Aretas Porfolio 1.0',
		image: 'https://i.postimg.cc/1XQ2WC7H/the-nexter-project-min.png',
		description:
			'This is my first personal project based on just HTML, CSS, Javascript and A free API (For the Quote generator). No Frameworks involved!',
		link: 'https://ndimofor-aretas.netlify.app/',
	},

	{
		id: 5,
		title: 'Ndimofor Aretas Porfolio 1.0',
		image: 'https://i.postimg.cc/dQ2z7FDS/the-youtube-app-min.png',
		description:
			'This is my first personal project based on just HTML, CSS, Javascript and A free API (For the Quote generator). No Frameworks involved!',
		link: 'https://ndimofor-aretas.netlify.app/',
	},

	{
		id: 6,
		title: 'Ndimofor Aretas Porfolio 1.0',
		image: 'https://i.postimg.cc/vTwFJHT5/the-nurce-app-min.png',
		description:
			'This is my first personal project based on just HTML, CSS, Javascript and A free API (For the Quote generator). No Frameworks involved!',
		link: 'https://ndimofor-aretas.netlify.app/',
	},
];
